import React from "react";
import { Route } from "react-router-dom";
import ViewVehicleReport from "../views/reports/ViewVehicleReport.js";
import ViewInventoryReport from "../views/reports/ViewInventoryReport.js";
import InventoryTransactionReport from "../views/reports/InventoryTransactionReport.js";
import DailyProgressReport from "../views/reports/DailyProgressReport.js";
import VehicleReadingReport from "../views/reports/VehicleReadingReport.js";
import VehicleHireReport from "../views/reports/VehicleHireReport.js";
import StockInReport from "../views/reports/StockInReport.js";
import StockInSummaryReport from "../views/reports/StockInSummaryReport.js";
import StockOutReport from "../views/reports/StockOutReport.js";
import ProjectVehicleReport from "../views/reports/ProjectVehicleReport.js";
import PettyCashExpenseReport from "../views/reports/PettyCashExpenseReport.js";
import PettyCashPaymentsReport from "../views/reports/PettyCashPaymentsReport.js";
import FuelConsumptionReport from "../views/reports/FuelConsumptionReport.js";
import FuelPurchaseReport from "../views/reports/FuelPurchaseReport.js";
import StockReturnReport from "../views/reports/StockReturnReport.js";
import StockTransferReport from "../views/reports/StockTransferReport.js";
import StockSalesReport from "../views/reports/StockSalesReport.js";
import MaterialReconciliationReport from "../views/reports/MaterialReconciliationReport.js";
import MaterialConsumptionReport from "../views/reports/MaterialConsumptionReport.js";
import DprLabourReport from "../views/reports/DprLabourReport.js";
import VehicleSummaryReport from "../views/reports/VehicleSummaryReport.js";


const ReportRoutes = [
    <Route key="vehiclereport" path="vehiclereport/view" element={<ViewVehicleReport />} />,
    <Route key="inventoryreport" path="inventoryreport/view" element={<ViewInventoryReport />} />,
    <Route key="inventorytransactionreport" path="inventorytransactionreport/view" element={<InventoryTransactionReport />} />,
    <Route key="dailyprogressreport" path="dailyprogressreport/view" element={<DailyProgressReport />} />,
    <Route key="vehiclereadingreport" path="vehiclereadingreport/view" element={<VehicleReadingReport />} />,
    <Route key="vehiclehirereport" path="vehiclehirereport/view" element={<VehicleHireReport />} />,
    <Route key="stockinreport" path="stockinreport/view" element={<StockInReport />} />,
    <Route key="stockinsummaryreport" path="stockinsummaryreport/view" element={<StockInSummaryReport />} />,
    <Route key="stockoutreport" path="stockoutreport/view" element={<StockOutReport />} />,
    <Route key="projectvehiclereport" path="projectvehiclereport/view" element={<ProjectVehicleReport />} />,
    <Route key="pettycashexpensereport" path="pettycashexpensereport/view" element={<PettyCashExpenseReport />} />,
    <Route key="pettycashpaymentsreport" path="pettycashpaymentsreport/view" element={<PettyCashPaymentsReport />} />,
    <Route key="fuelconsumptionreport" path="fuelconsumptionreport/view" element={<FuelConsumptionReport />} />,
    <Route key="fuelpurchasereport" path="fuelpurchasereport/view" element={<FuelPurchaseReport />} />,
    <Route key="stockreturnreport" path="stockreturnreport/view" element={<StockReturnReport />} />,
    <Route key="stocktransferreport" path="stocktransferreport/view" element={<StockTransferReport />} />,
    <Route key="stocksalesreport" path="stocksalesreport/view" element={<StockSalesReport />} />,
    <Route key="materialreconciliationreport" path="materialreconciliationreport/view" element={<MaterialReconciliationReport />} />,
    <Route key="materialconsumptionreport" path="materialconsumptionreport/view" element={<MaterialConsumptionReport />} />,
    <Route key="dprlabourreport" path="dprlabourreport/view" element={<DprLabourReport />} />,
    <Route key="vehiclesummaryreport" path="vehiclesummaryreport/view" element={<VehicleSummaryReport />} />,
];

export default ReportRoutes;
